import { useState } from "react";
import Sidebar from "./Sidebar";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export default function JobregisterPage() {

  const API_URL = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    jobtitle: "",
    jobdescription: "",
    department: "",
    jobtype: "", 
    location: "",
    qualification: "",
    experience: "",
    budget: "",
  });


  
const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'bullet' }],
    ['link'],
    ['clean'] // remove formatting button
  ],
};

const formats = [
  'header',
  'bold', 'italic', 'underline',
  'list',
  'link',
];

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    
    console.log("Sending data:", {
      ...formData,
      budget: Number(formData.budget),
    });

    try {
      const response = await fetch(`${API_URL}/api/career/jobpost`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          budget: formData.budget.toString(), // 👈 Make sure it's a string if backend expects string
        }),  
      });

      const result = await response.json();

      if (response.ok) {
        setMessage("Job posted successfully! ✅");
        setFormData({
          jobtitle: "",
          jobdescription: "",
          department: "",
          jobtype: "", 
          location: "",
          qualification: "",
          experience: "",
          budget: "",
        });
      } else {
        console.error("Backend error:", result); // ✅ Log backend error
        setMessage(result.error || "Failed to post job ❌");
      }
    } catch (error) {
      console.error("Submission Error:", error);
      setMessage("Something went wrong. Please try again later ❌");
    }
  };

  return (
    <div className="w-screen pt-[2%] px-[1%] h-auto bg-[#f1f2f6] flex flex-row">
      <Sidebar />

      <div className="flex w-full ml-2">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-6xl bg-white p-6 rounded-lg shadow-md flex flex-col gap-4"
        >
          {/* Input fields */}
          <div className="grid grid-cols-2 gap-4">
            <input
              type="text"
              name="jobtitle"
              value={formData.jobtitle}
              onChange={handleChange}
              placeholder="Job Title"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="department"
              value={formData.department}
              onChange={handleChange}
              placeholder="Department / Function"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="jobtype"
              value={formData.jobtype}
              onChange={handleChange}
              placeholder="Job Type (e.g., Full-Time, Part-Time)"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Location"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="qualification"
              value={formData.qualification}
              onChange={handleChange}
              placeholder="Qualification"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              placeholder="Experience (e.g., 2-3 years)"
              className="p-2 border border-gray-300 rounded"
              required
            />

            <input
              type="text"
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              placeholder="Budget (e.g., 80000 to 100000 LPA)"
              className="p-2 border border-gray-300 rounded"
              required
            />
          </div>

         {/* Description */}
<div className="mb-6">
  <ReactQuill
    value={formData.jobdescription}
    onChange={(value) => setFormData({ ...formData, jobdescription: value })}
    placeholder="Job Description"
    modules={modules}
    formats={formats}
    className="w-full"
  />
</div>


          {/* Submit */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-600 mt-[3%] hover:bg-blue-700 text-white p-2 px-8 rounded"
            >
              Post Job
            </button>
          </div>

          {/* Message */}
          {message && (
            <p
              className={`text-md mt-2 text-right ${
                message.includes("✅") ? "text-green-600" : "text-red-600"
              }`}
            >
              {message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
